import { render, staticRenderFns } from "./SaveDefaultButton.vue?vue&type=template&id=3fba23c7&scoped=true"
import script from "./SaveDefaultButton.vue?vue&type=script&lang=js"
export * from "./SaveDefaultButton.vue?vue&type=script&lang=js"
import style0 from "./SaveDefaultButton.vue?vue&type=style&index=0&id=3fba23c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba23c7",
  null
  
)

export default component.exports